import React, { useState, useRef, useEffect } from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Overlay,
  Popover,
  Button,
} from "react-bootstrap";
import ReactSelect from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import Flatpickr from "react-flatpickr";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchIndustryData,
  setSelectedIndustry,
} from "../../redux/actions/industryActions";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import {
  fetchCompanyCategories,
  selectCompanyCategory,
} from "../../redux/actions/companyCategoryActions";
import { fetchJobType, selectJobType } from "../../redux/actions/jobTypeAction";
import {
  fetchWorkLevelTypeData,
  selectWorkLevel,
} from "../../redux/actions/workLevelTypeAction";
import {
  fetchWorkLocationTypeData,
  selectLocationType,
  selectWorkLocation,
} from "../../redux/actions/workLLocationTypeAction";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { customStyles } from "../../selectStyles";
import axiosInstance from "../../API/axios";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import { useParams } from "react-router-dom";
import {
  fetchCompanyData,
  selectGetCompanies,
} from "../../redux/actions/getCompaniesAction";
import moment from "moment";

const EditExperience = ({
  show,
  handleClose,
  userCcv,
  userDataInfo,
  experienceData,
}) => {
  console.log("user experience", experienceData);
  const [institution, setInstitution] = useState(null);
  const [city, setCity] = useState(null);
  const [field, setField] = useState("");
  const [degree, setDegree] = useState("");
  const [grade, setGrade] = useState("");
  const [isPresent, setIsPresent] = useState(false);
  const [startYear, setStartYear] = useState("");
  const [endYear, setEndYear] = useState("");
  const [description, setDescription] = useState("");
  const [activities, setActivities] = useState("");

  const [showTooltip, setShowTooltip] = useState(false);
  const targetRef = useRef(null);
  const [newEducation, setNewEducation] = useState("");

  const sessionId = localStorage.getItem("sessionId");
  const userType = localStorage.getItem("userType");
  const { CandidateId } = useParams();

  const [profileHeadLine, setProfileHeadLine] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  console.log("");

  const [designation, setDesignation] = useState("");
  const [OrganizationName, setOrganizationName] = useState("");
  const [display, setDisplay] = useState(false);
  const [newOrgType, setnewOrgType] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisplay(true);
    const body = {
      sessionId: sessionId,
      userDataId: userDataInfo.userDataId,
      userType: userType,
      instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
      orgType: companyListId === null ? newOrgType : orgType,
      compID: companyListId,
      gnrlOrgCompID: getOrgInsTId,
      positionHeadline: profileHeadLine,
      designation: designation,
      description: description,
      cityId: citySearch,
      jobTypeId: jobTypeId,
      workLocationTypeId: workLocationId,
      workLevelTypeId: workLevelId,
      startDate: moment(startDate).format("YYYY-MM-DD"),
      isPresent: isPresent,
      endDate:
        endDate === "" || endDate === null
          ? null
          : moment(endDate).format("YYYY-MM-DD"),
      expId: experienceData.usrDataExpId,
    };
    console.log("body workLocationId", body, workLocationId);

    try {
      const res = await axios.post("/Resume/UpdateExperience", body);
      toast.success(res.data.message);
      handleClose("");
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.warning(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };

  // const handleSaveInstitution = () => {
  //     console.log("New Institution Created:", newEducation);
  //     setShowTooltip(false);
  //     setNewEducation("");
  // };

  const [fileName, setFileName] = useState(""); // State to store selected filename
  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      setFileName(file.name); // Set the filename in state
    }
  };
  const toggleTooltip = () => {
    console.log("Toggling Tooltip");
    setShowTooltip((prev) => !prev);
  };

  // ...............................City DDL.......................................
  const dispatch = useDispatch();

  const [orgCity, setOrgCity] = useState(null);
  const [citySearch, setCitySearch] = useState("");
  const { cityList, selectedcityId } = useSelector((state) => state.cities);
  useEffect(() => {
    dispatch(fetchCityData());
  }, [dispatch]);
  const handleCitySelect = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectCity(selectedOption.value));
      setCitySearch(selectedOption.value);
    }
  };
  const handleCitySelect1 = (selectedOption) => {
    if (selectedOption) {
      setOrgCity(selectedOption.value);
    }
  };

  // ...............................City DDL.......................................
  // ...............................Job Type DDL.......................................
  const [jobTypeId, setJobTypeId] = useState("");
  const { jobTypeList, selectedJobTypeId } = useSelector(
    (state) => state.jobType
  );
  // console.log('job type',jobTypeList,selectedJobTypeId);

  useEffect(() => {
    dispatch(fetchJobType());
  }, [dispatch]);

  const handleJobType = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectJobType(selectedOption.value));
      setJobTypeId(selectedOption.value);
    }
  };
  // ...............................Job Type DDL.......................................
  // ...............................Work Level DDL.......................................
  // Fetch work level data on component mount
  const [workLevelId, setWorkLevelId] = useState("");
  const { workLevelList, selectedworkLevelId } = useSelector(
    (state) => state.workLevelType
  );
  // console.log("Work Level", workLevelList, selectedworkLevelId);

  useEffect(() => {
    dispatch(fetchWorkLevelTypeData());
  }, [dispatch]);

  const handleWorkLevel = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectWorkLevel(selectedOption.value));
      setWorkLevelId(selectedOption.value);
    }
  };

  // ...............................Work Level DDL.......................................
  // ...............................Work Location DDL.......................................

  // Fetch work location data on component mount
  const [workLocationId, setworkLocationId] = useState("");
  const { workLocation, selectedCategoryId } = useSelector(
    (state) => state.workLocationType
  );

  useEffect(() => {
    dispatch(fetchWorkLocationTypeData());
  }, [dispatch]);

  const handleWorkLoc = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectWorkLocation(selectedOption.label));
      setworkLocationId(selectedOption.value);
    }
  };

  // ...............................Location DDL.......................................

  // ...............................Company Category DDL.......................................
  const [orgType, setOrgType] = useState("");
  const [companyListId, setCompanyListId] = useState("");
  const { getcompaniesList, selectedcompaniesId } = useSelector(
    (state) => state.getcompanies
  );

  useEffect(() => {
    dispatch(fetchCompanyData());
  }, [dispatch]);

  const handleSelectCompany = (selectedOption) => {
    console.log("selectedOption", selectedOption);

    if (selectedOption) {
      // dispatch(selectGetCompanies(selectedOption.value));
      setCompanyListId(selectedOption.value);
      setOrgType(selectedOption.tag);
    }
  };
  const [getOrgInsTId, setGenOrgInstId] = useState(null);
  // ...............................Company Category DDL.......................................

  const handleSaveInstitution = async () => {
    // setDisplay(true);

    const formData = new FormData();
    formData.append("orgName", OrganizationName);
    formData.append("OrgType", "UnRegdInstitution");
    formData.append("CityID", orgCity);
    formData.append("OrgLogo", fileName);
    formData.append("sessionId", sessionId);
    console.log("formData", formData);
    if (
      (companyListId === '' && getOrgInsTId === '') ||
      (orgType === '' && newOrgType === '') ||
      designation === '' ||
      jobTypeId === '' ||
      workLevelId === '' ||
      workLocationId === '' ||
      citySearch === '' ||
      startDate === ''
    ) {
      toast.error('Please fill all the required fields');
    } else {
      try {
        const res = await axios.post("/CandidateData/AddGnrlOrgData", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        console.log("res", res);
        setGenOrgInstId(res.data.responseData.id);
        setnewOrgType(res.data.responseData.value);
        setShowTooltip(false);
        toast.success(res.data.message);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          toast.warning(error.response.data.message);
        } else {
          toast.error(error.response?.data?.message || "An error occurred");
        }
      }
    }
  };

  // update experience .....

  const [industryDataId, setIndustryDataId] = useState(null);

  useEffect(() => {
    if (experienceData) {
      setOrgType(experienceData?.orgTypeId);
      setCompanyListId(experienceData?.compId);
      setDesignation(experienceData?.jobTitle);
      setProfileHeadLine(experienceData.positionHeadline);
      setDescription(experienceData?.description);
      setJobTypeId(experienceData?.jobType);
      setWorkLevelId(experienceData?.workLevelType);
      setworkLocationId(experienceData?.workLocationType);
      setCitySearch(experienceData?.cityId);
      setIsPresent(experienceData?.isPresent);
      setStartDate(experienceData?.startDate);
      setEndDate(experienceData?.endDate);
    }
  }, [experienceData]);

  console.log("industryDataId", industryDataId, experienceData);
  const [InsName, setInsName] = useState("");

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header>
        <Modal.Title>Update Experience</Modal.Title>
        <CloseSharpIcon className="pointer" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body className="settings">
        <Row>
          {/* Institution and City */}
          <Col md={6}>
            <Form.Group controlId="institution">
              <Form.Group controlId="Company">
                <Form.Label className="class-type">
                  Company
                  <span style={{ color: "red" }} className="ms-2">
                    *
                  </span>
                </Form.Label>
                {InsName !== "" ? (
                  <div>
                    <input
                      type="text"
                      value={InsName}
                      placeholder="Enter Org name"
                      className="mb-2 form-control"
                      disabled
                    />
                  </div>
                ) : (
                  <div className="post-form-group mb-0">
                    <ReactSelect
                      options={getcompaniesList}
                      onChange={handleSelectCompany}
                      value={
                        getcompaniesList.find(
                          (option) => option.value === companyListId
                        ) || null
                      }
                      placeholder="Select Company"
                      classNamePrefix="react-select"
                      className="form-control"
                      styles={customStyles}
                    />
                  </div>
                )}
              </Form.Group>
              <a
                href="#"
                ref={targetRef}
                onClick={(e) => {
                  e.preventDefault();
                  toggleTooltip();
                }}
                className="createModal"
              // isDisabled={!selectedIndustryId} // Disable until industry is selected
              >
                Create New
              </a>
              <Overlay
                target={targetRef.current}
                show={showTooltip}
                placement="right"
                rootClose
                container={document.querySelector(".modal")}
                onHide={() => setShowTooltip(false)} // Close when clicking outside
              >
                <Popover id="popover-basic">
                  <Popover.Header as="h3" className="Dark-Body-Card-group">Create Organization</Popover.Header>
                  <Popover.Body className="Dark-Body-Card-group">
                    <Form>
                      <div>
                        <label className="mb-1 Text-mb-Create">Org name</label>
                        <input
                          type="text"
                          value={OrganizationName}
                          onChange={(e) => {
                            setOrganizationName(e.target.value);
                            setInsName(e.target.value);
                          }}
                          placeholder="Enter Org name"
                          className="mb-2 form-control  Dark-Input-from-group"
                        />
                      </div>
                      <div>
                        <label className="mb-1 Text-mb-Create">City</label>
                        <ReactSelect
                          options={cityList}
                          onChange={handleCitySelect1}
                          value={
                            cityList.find(
                              (option) => option.value === orgCity
                            ) || null
                          }
                          placeholder="Select City"
                          classNamePrefix="react-select"
                          className="form-control  Dark-Input-from-group"
                          styles={customStyles}
                        />
                      </div>
                      <div className=" mt-2 mb-2 Text-mb-Create">
                        <label className="mb-1">Org Logo</label>
                        <input
                          type="file"
                          id="lastName"
                          className="form-control  Dark-Input-from-group"
                          placeholder=""
                          onChange={handleFileChange}
                        //   onChange={(e) => {
                        //     handleProfileImageChange(e);
                        //   }}
                        //   invalid={displays && profileImage === ""}
                        />
                        {/* {displays && !profileImage ? (
                        <span className="error_msg_lbl text-red">
                          Upload Image{" "}
                        </span>
                      ) : null} */}
                      </div>
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="primary"
                          size="sm"
                          onClick={handleSaveInstitution}
                          className="me-2"
                        >
                          Save
                        </Button>
                        <Button
                          variant="secondary"
                          size="sm"
                          onClick={() => setShowTooltip(false)}
                        >
                          Cancel
                        </Button>
                      </div>
                    </Form>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </Form.Group>
          </Col>
          {/* <Col md={6}>
          <Form.Group controlId="Company">
            <Form.Label className="class-type">
              Company
              <span style={{ color: "red" }} className="ms-2">
                *
              </span>
            </Form.Label>
          </Form.Group>
          <div className="post-form-group">
            <ReactSelect
              options={categories}
              onChange={handleCompanySelect}
              // onChange={(e) => handleCompanySelect}
              value={
                categories.find(
                  (option) => option.value === selectedCompanyCategoryId
                ) || null
              }
              placeholder="Select Company"
              classNamePrefix="react-select"
              className="form-control"
              styles={customStyles}
            />
          </div>
        </Col> */}

          {/* Field, Degree, and Grade */}
          <Col md={6}>
            <Form.Group controlId="grade">
              <Form.Label className="class-type">Designation</Form.Label>
              <Form.Control
                type="text"
                className="Dark-Input-from-group"
                value={designation}
                onChange={(e) => setDesignation(e.target.value)}
                placeholder="Enter Designation"
              />
              {display && !designation ? (
                <span className="error_msg_lbl">Enter Designation </span>
              ) : null}
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="grade">
              <Form.Label className="class-type">Profile Headline</Form.Label>
              <Form.Control
                type="text"
                className="Dark-Input-from-group"
                value={profileHeadLine}
                onChange={(e) => setProfileHeadLine(e.target.value)}
                placeholder="Profile Headline"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="city">
              <Form.Label className="class-type">
                Employment type (Job Type)
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </Form.Label>
            </Form.Group>
            <div className="post-form-group">
              <ReactSelect
                options={jobTypeList}
                onChange={handleJobType}
                value={
                  jobTypeList.find((option) => option.value === jobTypeId) ||
                  null
                }
                placeholder="Select Employment type"
                classNamePrefix="react-select"
                className="form-control"
                styles={customStyles}
              />
            </div>
            {display && !jobTypeId ? (
              <span className="error_msg_lbl">Select Employment type </span>
            ) : null}
          </Col>
          <Col md={6}>
            <Form.Group controlId="city">
              <Form.Label className="class-type">
                Work Level Type
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </Form.Label>
            </Form.Group>
            <div className="post-form-group">
              <ReactSelect
                options={workLevelList}
                onChange={handleWorkLevel}
                value={
                  workLevelList.find(
                    (option) => option.value === workLevelId
                  ) || null
                }
                placeholder="Select Work Level Type"
                classNamePrefix="react-select"
                className="form-control"
                styles={customStyles}
              />
            </div>
            {display && !workLevelId ? (
              <span className="error_msg_lbl">Select Work Level Type</span>
            ) : null}
          </Col>

          {/* Start Year, End Year, Is Present */}
          <Col md={6}>
            <Form.Group controlId="city">
              <Form.Label className="class-type">
                Work Location Type
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </Form.Label>
            </Form.Group>
            <div className="post-form-group">
              <ReactSelect
                options={workLocation}
                onChange={handleWorkLoc}
                value={
                  workLocation.find(
                    (option) => option.value === workLocationId
                  ) || null
                }
                placeholder="Select Work Location Type"
                classNamePrefix="react-select"
                className="form-control"
                styles={customStyles}
              />
            </div>
            {display && !workLocationId ? (
              <span className="error_msg_lbl">Select Work Location Type</span>
            ) : null}
          </Col>
          <Col md={6}>
            <Form.Group controlId="city">
              <Form.Label className="class-type">
                City
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </Form.Label>
            </Form.Group>
            <div className="post-form-group">
              <ReactSelect
                options={cityList}
                onChange={handleCitySelect}
                value={
                  cityList.find((option) => option.value === citySearch) || null
                }
                placeholder="Search and Select City "
                classNamePrefix="react-select"
                className="form-control"
                styles={customStyles}
              />
            </div>
            {display && !citySearch ? (
              <span className="error_msg_lbl">Select City</span>
            ) : null}
          </Col>
          <Col md={6}>
            <Form.Group controlId="endYear">
              <Form.Label className="class-type">Start Year</Form.Label>
              <Flatpickr
                type="number"
                value={startDate}
                onChange={(date) => setStartDate(date[0])}
                placeholder="Enter Start Year"
              // disabled={isPresent}
              />
              {display && !startDate ? (
                <span className="error_msg_lbl">Enter Start Year</span>
              ) : null}
            </Form.Group>
          </Col>
          {userDataInfo.isPresentExperience === true && isPresent === false ? (
            ""
          ) : (
            <Col md={6} className="d-flex align-items-center">
              <Form.Check
                type="checkbox"
                label="Is Present"
                checked={isPresent}
                onChange={(e) => setIsPresent(e.target.checked)}
              />
            </Col>
          )}
          {isPresent === false ? (
            <Col md={6}>
              <Form.Group controlId="endYear">
                <Form.Label className="class-type">End Year</Form.Label>
                <Flatpickr
                  type="number"
                  value={endDate}
                  onChange={(date) => setEndDate(date[0])}
                  placeholder="Enter End Year"
                  options={{
                    minDate: startDate || null, // Set minDate to startDate
                  }}
                />
              </Form.Group>
            </Col>
          ) : (
            " "
          )}

          <Col md={12}>
            <Form.Group controlId="description">
              <Form.Label className="class-type">Description</Form.Label>
              <Form.Control
                as="textarea"
                className="Dark-Input-from-group"
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter Description"
              />
            </Form.Group>
          </Col>

          {/* Description */}
        </Row>

        {/* Submit Button */}
        <div className="d-flex justify-content-end mt-4">
          {/* <Button variant="secondary" onClick={handleClose} className="me-3">
                      Close
                  </Button> */}
          <div className="add-class-submit-button mt-4 d-flex justify-content-center">
            <div className="khojPrimaryBtn ms-3">
              <a href="#/" onClick={handleSubmit}>
                Submit
              </a>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EditExperience;
